<div class="flex justify-between mx-2">
  <h1 class="text-xl font-bold text-blue-800 shadow-sm">
    {{ title }}
  </h1>
  <button
    class="bg-blue-500 p-3 px-5 rounded-md font-semibold text-white flex items-center space-x-4 gap-2 mb-2 hover:bg-blue-600"
    (click)="print()"
  >
    <mat-icon>print</mat-icon>
    Imprimer
  </button>
  <button
    class="bg-red-500 p-3 px-5 rounded-md font-semibold text-white flex items-center space-x-4 gap-2 mb-2 hover:bg-red-600"
    (click)="logTable()"
  >
    <mat-icon>print</mat-icon>
    log
  </button>
</div>

<!--*******************start: rapport TablePreviewEtatTarif******************* -->
<!--*******************start: rapport TablePreviewEtatTarif ******************* -->
<!--*******************start: rapport TablePreviewEtatTarif ******************* -->
<div *ngIf="isTarifRapport">
  <div
    id="header-page"
    class="bg-gray-200 p-4 flex justify-between items-center"
    style="display: flex"
  >
    <h2 class="text-lg font-bold">{{ circuitName }}</h2>
    <p class="text-gray-600">{{ numDays }} jours</p>
    <p class="text-gray-600">{{ nbrPeronnes }} personne(s)</p>
    <p class="text-gray-600">{{ numAccompagnant }} accompagnant(s)</p>
    <p class="text-gray-600">
      {{ dateArrivee | date }} - {{ dateDepart | date }}
    </p>
    <p class="text-gray-600">{{ reference }}</p>
  </div>

  <div
    id="myTable"
    class="border-b border-gray-200"
    style="overflow: auto; max-height: 90vh"
  >
    <!--*******************start: rapport détail TablePreviewEtatTarif ******************* -->
    <div
      class="shadow rounded-lg bg-white"
      *ngFor="let typeEvent of TablePreviewEtatTarif"
    >
      <!-- header Day item -->
      <div class="flex items-center justify-between">
        <span
          class="text-2xl font-bold"
          style="font-size: x-large; font-weight: 800"
        >
          Prestation : {{ typeEvent.typeEvennementText }}
        </span>
        <!-- <span class="text-xl font-bold">
                Date : 
            </span> -->
      </div>
      <!-- header Day item -->

      <!-- ****************start: la list des evenements dans un journée ****************-->
      <div>
        <!-- Tableau general de détail de calcul de chaque evenement -->

        <div class="table-container">
          <table
            class="w-full bg-white"
            style="
              border: 1px solid black;
              border-collapse: collapse;
              font-size: 10pt;
            "
          >
            <thead class="bg-gray-400 text-gray-800">
              <tr>
                <th
                  class="text-left uppercase font-semibold text-xs px-8"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Evenement
                </th>
                <th
                  class="text-left uppercase font-semibold text-xs px-8"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Fournisseur
                </th>

                <th
                  class="text-left uppercase font-semibold text-xs px-8"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Type Tarif
                </th>
                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Observation
                </th>

                <th
                  class="text-left uppercase py-2 px-8 font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Accompagnant
                </th>
                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Guide
                </th>
                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Chauffeur
                </th>

                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Tarif
                </th>

                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Total collective
                </th>
                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Total individuel
                </th>

                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Modif Accompagnant
                </th>

                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Modif Guide
                </th>

                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Modif Chauffeur
                </th>
                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Modif Tarif
                </th>

                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Modif Individuel
                </th>

                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Modif collective
                </th>
              </tr>
            </thead>
            <tbody
              class="text-gray-700"
              style="border: 1px solid black; border-collapse: collapse"
            >
              <ng-container *ngFor="let event of typeEvent.events">
                <tr>
                  <td
                    [attr.rowspan]="event.tarifs?.length + 1"
                    class="text-center px-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{ event.TravelD_Event }}
                  </td>
                  <td
                    [attr.rowspan]="event.tarifs?.length + 1"
                    class="text-center px-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{ event.Tiers_RS }}
                  </td>
                </tr>

                <ng-container
                  *ngFor="let detailEvent of event.tarifs; index as i"
                >
                  <tr [class]="i % 2 == 0 ? 'bg-gray-100' : ''">
                    <td
                      class="text-center pl-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.Type_Tarif }}
                    </td>
                    <td
                      class="text-center py-2 px-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.Observation }}
                    </td>
                    <td
                      class="text-center py-2 px-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.TravelDM_Accompagniant }}
                    </td>
                    <td
                      class="text-center py-2 px-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.TravelDM_guide }}
                    </td>
                    <td
                      class="text-center"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.TravelDM_Chauffeur }}
                    </td>
                    <td
                      class="text-center py-2 px-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.TravelDM_Tarif }}
                    </td>
                    <td
                      class="text-center py-2 px-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.TravelDM_Total_COLL }}
                    </td>
                    <td
                      class="text-center py-2 px-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.TravelDM_Total_IND }}
                    </td>
                    <td
                      class="text-center py-2 px-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.TravelDM_AccompModif }}
                    </td>

                    <td
                      class="text-center py-2 px-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.TravelDM_guideModif }}
                    </td>

                    <td
                      class="text-center py-2 px-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.TravelDM_ChauffeurModif }}
                    </td>

                    <td
                      class="text-center py-2 px-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.TravelDM_Tarif_Modif }}
                    </td>

                    <td
                      class="text-center py-2 px-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.TravelDM_Total_INDModif }}
                    </td>

                    <td
                      class="text-center py-2 px-8"
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ detailEvent.TravelDM_Coll_Modif }}
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
        <!-- Tableau supp de détail de calcul de chaque evenement -->
        <!-- <span class="text-gray-800 text-xl">Liste des Supplements :</span> -->
        <!-- <div class="my-2">
                    <table class="w-full bg-white "
                    style="border: 1px solid black;
                    border-collapse: collapse;">
                        <thead class="bg-gray-300 text-gray-900">
                                    <tr>
                                    <th class="text-left uppercase font-semibold text-xs px-16"
                                    style="border: 1px solid black;
                                border-collapse: collapse;">
                                    Type Tarif
                                    </th>
                                    <th class="text-left  px-16 uppercase font-semibold text-xs"
                                    style="border: 1px solid black;
                                border-collapse: collapse;">
                                    Observation
                                    </th>
                                    <th class="text-left  px-16 uppercase font-semibold text-xs"
                                    style="border: 1px solid black;
                                border-collapse: collapse;">
                                    Supplement
                                    </th>
                          
                                    <th class="text-left uppercase font-semibold text-xs px-16"
                                    style="border: 1px solid black;
                                border-collapse: collapse;">
                                    Modif Supplement
                                    </th>
                          
                                    </tr>
                          </thead>
                        <tbody class="text-gray-700 ">
                          <ng-container   *ngFor="let detailEventSupp of event.TarifEvent; index as i">
                            <tr *ngIf="detailEventSupp.TravelDM_SUPP > 0" [class]="i % 2 == 0 ? 'bg-gray-100' : ''">
                                <td class="text-center py-1 px-16"
                                style="border: 1px solid black;
                                border-collapse: collapse;">
                                  {{ detailEventSupp.Type_Tarif }}
                                </td>
                                <td class="text-center py-1 px-16"
                                style="border: 1px solid black;
                                border-collapse: collapse;">
                                  {{ detailEventSupp.Observation }}
                                </td>
                                <td class="text-center py-1 px-16"
                                style="border: 1px solid black;
                                border-collapse: collapse;">
                                  {{ detailEventSupp.TravelDM_SUPP }}
                                </td>
                      
                                <td class="text-center"
                                style="border: 1px solid black;
                                border-collapse: collapse;">
                                  <input id="suppModif" [readOnly]="true" type="number"
                                    [value]="detailEventSupp.TravelDM_Supp_Modif" class="rounded-md border text-center p-2"
                                    style="width: 50px;  border-style: none;" />
                                </td>
                    
                              </tr>
                          </ng-container>
                        </tbody>
                      </table>
                </div> -->
      </div>
      <!-- ****************end: la list des evenements dans un journée ****************-->
      <hr class="my-2 hr-separte" />
    </div>
    <!--*******************end: la liste des jours dans le circuit ******************* -->
  </div>
</div>

<!--*******************end: rapport TablePreviewEtatTarif******************* -->
<!--*******************end: rapport TablePreviewEtatTarif ******************* -->
<!--*******************end: rapport TablePreviewEtatTarif ******************* -->

<!--*******************start: rapport TablePreviewEtatCircuit******************* -->
<!--*******************start: rapport TablePreviewEtatCircuit ******************* -->
<!--*******************start: rapport TablePreviewEtatCircuit ******************* -->
<div *ngIf="!isTarifRapport">
  <!--*******************start: Header Circuit ******************* -->
  <div
    id="header-page"
    class="bg-gray-200 p-4 flex justify-between items-center"
    style="display: flex"
  >
    <h2 class="text-lg font-bold">{{ circuitName }}</h2>
    <p class="text-gray-600">{{ numDays }} jours</p>
    <p class="text-gray-600">{{ nbrPeronnes }} personne(s)</p>
    <p class="text-gray-600">{{ numAccompagnant }} accompagnant(s)</p>
    <p class="text-gray-600">
      {{ dateArrivee | date }} - {{ dateDepart | date }}
    </p>
    <p class="text-gray-600">{{ reference }}</p>
  </div>
  <!--*******************end: Header Circuit ******************* -->

  <div
    id="myTable"
    class="border-b border-gray-200"
    style="overflow: auto; max-height: 90vh"
  >
    <!--*******************start: rapport détail TablePreviewEtatCircuit ******************* -->
    <div
      class="shadow rounded-lg bg-white"
      *ngFor="let day of TablePreviewEtatCircuit; index as i"
    >
      <!-- header Day item -->
      <div class="my-3" style="margin-top: 10px; margin-bottom: 5px">
        <ng-container *ngIf="i == 0">
          <hr class="hr-text" [attr.data-content]="'Details'" />
          Details
        </ng-container>
        <ng-container *ngIf="i != 0">
          <hr class="hr-text" [attr.data-content]="'JOUR ' + i" />
          <div style="display: flex; justify-content: space-between">
            <div>
              <span style="font-weight: 600; font-size: medium">
                villes visitées :</span
              >
              <ng-container
                *ngFor="let ville of day.visited_cities; index as index_v"
              >
                <span
                  style="color: steelblue; font-weight: 500; font-size: medium"
                >
                  {{
                    index_v != day.visited_cities.length - 1
                      ? ville + " 🠪 "
                      : ville
                  }}
                </span>
              </ng-container>
            </div>
            <div>
              <span style="font-weight: 600; font-size: medium">Date : </span>
              <span
                style="color: #3730a3; font-weight: 600; font-size: medium"
                >{{ day.visited_date | date : "shortDate" }}</span
              >
            </div>
          </div>
        </ng-container>
      </div>
      <!-- header Day item -->

      <!-- ****************start: la list des evenements dans un journée ****************-->
      <div>
        <!-- Tableau general de détail de calcul de chaque evenement -->

        <div class="table-container">
          <table
            class="w-full bg-white"
            style="
              border: 1px solid black;
              border-collapse: collapse;
              font-size: 10pt;
            "
          >
            <thead class="bg-gray-400 text-gray-800">
              <tr>
                <th
                  class="text-left uppercase font-semibold text-xs px-8"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  PRESTATION
                </th>
                <th
                  class="text-left uppercase font-semibold text-xs px-8"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  TYPE DE PRESTATION
                </th>

                <th
                  class="text-left uppercase font-semibold text-xs px-8"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  VILLE
                </th>
                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  FOURNISSEUR
                </th>

                <th
                  class="text-left uppercase py-2 px-8 font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  TYPE
                </th>
                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  OBSERVATION
                </th>
                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Durée du transport
                </th>
                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  H.Début
                </th>

                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  H.Fin
                </th>

                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Durée
                </th>
                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Kilometrage
                </th>

                <th
                  class="text-left py-2 px-8 uppercase font-semibold text-xs"
                  style="border: 1px solid black; border-collapse: collapse"
                >
                  Nombre des voitures
                </th>
              </tr>
            </thead>
            <tbody
              class="text-gray-700"
              style="border: 1px solid black; border-collapse: collapse"
            >
              <ng-container *ngFor="let event of day.liste; index as i">
                <tr [class]="i % 2 == 0 ? 'bg-gray-100' : ''">
                  <td
                    class="text-center pl-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{ event.typeEvennementText }}
                  </td>
                  <td
                    class="text-center py-2 px-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{ event.TravelD_Event }}
                  </td>
                  <td
                    class="text-center py-2 px-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{ event.TravelD_Ville }}
                  </td>
                  <td
                    class="text-center py-2 px-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{ event.Tiers_RS }}
                  </td>
                  <td
                    class="text-center"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{ event.typeText }}
                  </td>
                  <td
                    class="text-center py-2 px-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{ event.TravelD_Obs }}
                  </td>
                  <td
                    class="text-center py-2 px-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{ event.TravelD_HDeb }}
                  </td>
                  <td
                    class="text-center py-2 px-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{ event.TravelD_HFin }}
                  </td>
                  <td
                    class="text-center py-2 px-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{
                      generalService.ConvertisseurDureeEnChaine_Generic(
                        event.TravelD_Duree
                      )
                    }}
                  </td>

                  <td
                    class="text-center py-2 px-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{ event.TravelD_Km }}
                  </td>

                  <td
                    class="text-center py-2 px-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{
                      generalService.ConvertisseurDureeEnChaine_Generic(
                        event.TravelD_DureeTrajet
                      )
                    }}
                  </td>

                  <td
                    class="text-center py-2 px-8"
                    style="border: 1px solid black; border-collapse: collapse"
                  >
                    {{ event.TravelD_NbreVoiture }}
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
      <!-- ****************end: la list des evenements dans un journée ****************-->
      <hr class="my-2 hr-separte" />
    </div>
    <!--*******************end: la liste des jours dans le circuit ******************* -->
  </div>
</div>
<!--*******************end: rapport TablePreviewEtatCircuit******************* -->
<!--*******************end: rapport TablePreviewEtatCircuit ******************* -->
<!--*******************end: rapport TablePreviewEtatCircuit ******************* -->
